<template>
  <div class="container">
    <pre style="display: none">{{ pagination | pretty_json }}}</pre>
    <h1>Lista Estados</h1>
    <div class="card">
      <div class="card-body">
        <b-table striped hover :items="states" :fields="fields">
          <template #cell(actions)="row">
            <Actions
              :item="row.item"
              :view_show="false"
              :view_edit="$can('state:edit')"
              :view_delete="$can('state:delete')"
              edit_to="states_edit"
              @delete="delete_state"
            />
          </template>
        </b-table>
      </div>
    </div>
    <div class="overflow-auto mt-4">
      <b-pagination-nav
        v-model="page"
        :link-gen="linkGen"
        :number-of-pages="pagination.last_page"
        use-router
      ></b-pagination-nav>
    </div>
  </div>
</template>

<script>
import Actions from "@/components/Table/Actions.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Actions },
  data: () => {
    return {
      page: 1
    };
  },
  computed: {
    ...mapState("states", ["states", "pagination"]),
    fields() {
      return [
        { key: "initials", label: "Sigla" },
        { key: "name", label: "Estado" },
        { key: "ibge_id", label: "Cod. IBGE" },
        { key: "actions", label: "#", class: "col-1" }
      ];
    }
  },
  methods: {
    ...mapActions("states", ["ActionGetAll", "ActionDelete"]),
    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    },
    delete_state(state) {
      return state;
    }
  },
  async created() {
    if (this.$route.query.page > 1) {
      this.page = this.$route.query.page;
    }
    await this.ActionGetAll({ page: this.page });
  }
};
</script>

<style></style>
